import "./LaundryModal.css";
import useLaundry from "./useLaundry";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { getTranslatedText as translate } from "../../Localization/Translation";
import ServiceRequest from "../ServiceRequest/ServiceRequest.js";
import CreditCardForm from "../CreditCard/CreditCardForm.js";

function LaundryModal() {
  const {
    locale,
    handleClosePaymentModal,
    handleShowPaymentModal,
    Laundry,
    latitude,
    longitude,
    showPaymentModal,
    showServiceRequestModal,
    handleShowServiceRequestModal,
    handleCloseServiceRequestModal,
  } = useLaundry();

  return (
    <div className="LaundryModal">
      <div className="Laundry-Profile" dir="auto">
        {/* Laundry information header */}
        <div className="Laundry-Information-in-modal">
          <div className="laundry-name-fav-profile">
            {/* name and fav column */}
            <div className="laundry-name-fav-col-profile">
              <h5 className="laundry-name-profile">{Laundry.name}</h5>
              <p className="card-text card-fav-icon">
                {Laundry.fav === true ? (
                  <i className="bi bi-heart-fill like-icon-rate"></i>
                ) : (
                  <i className="bi bi-heart like-icon-rate"></i>
                )}
              </p>
            </div>

            {/* Laundry rate row */}
            <div className="laundry-name-fav-col-profile">
              <p className="card-text card-star-icon">
                <span>{Laundry.rate}</span>
                <span>/5.0</span>
                <i className="bi bi-star-fill star-icon-rate"></i>
              </p>
            </div>
          </div>

          {/* phone and location column */}
          <div className="laundry-phone-location-profile">
            <div>
              <span>
                <i className="bi bi-telephone-fill"></i>
              </span>
              <span>{Laundry.phone}</span>
            </div>
            <div>
              <span>
                <i className="bi bi-geo-alt-fill"></i>
              </span>
              <span>{Laundry.locate}</span>
            </div>
          </div>
        </div>

        <div className="Laundry-Services-in-modal" dir="auto">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <p className="Laundry-Services-profile-label">
              {translate("laundry-services-label", locale)}
            </p>
            <a
              target="_blank"
              rel="noreferrer"
              href={"https://maps.google.com/?q=" + latitude + "," + longitude}
              className="btn btn-primary move-to-map-btn"
            >
              <span>
                <i className="bi bi-pin-map-fill"></i>
              </span>
              <span>{translate("move-to-map-button", locale)}</span>
            </a>
          </div>
          <div className="">
            {Laundry.services.length ? (
              <div className="services-laundry-container">
                <table className="table">
                  <thead className="thead-dark">
                    <tr className="table-notification-details-header">
                      <th scope="col">#</th>
                      <th scope="col">
                        {translate("item-type-column-notification", locale)}
                      </th>
                      <th scope="col">
                        {translate("services-laundry-table-column", locale)}
                      </th>
                      <th scope="col">
                        {translate("size-laundry-table-column", locale)}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {Laundry.services.map((service, index) => {
                      return (
                        <tr key={service.serviceId}>
                          <th scope="row">{index + 1}</th>
                          <td>{service.itemType}</td>
                          <td>
                            {service.servicesOnItem.map(
                              (serviceOnItem, indexType) => {
                                if (
                                  indexType !==
                                  service.servicesOnItem.length - 1
                                )
                                  return (
                                    "(" +
                                    serviceOnItem.serviceName +
                                    " , " +
                                    serviceOnItem.servicePrice +
                                    ") - "
                                  );
                                else
                                  return (
                                    "(" +
                                    serviceOnItem.serviceName +
                                    " , " +
                                    serviceOnItem.servicePrice +
                                    ")"
                                  );
                              }
                            )}
                          </td>
                          <td>{service.serviceWeight}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
                <div className="add-service-btn-div">
                  <Button
                    onClick={handleShowServiceRequestModal} //connect with api
                    className="btn btn-primary"
                  >
                    <span>
                      <i className="bi bi-plus-lg"></i>
                    </span>
                    <span>{translate("request-service-button", locale)}</span>
                  </Button>
                </div>
              </div>
            ) : (
              <div className="no-services">
                هذه المغسلة لا تقدم أي خدمات بعد
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Request Service Modal */}
      <Modal
        show={showServiceRequestModal}
        onHide={handleCloseServiceRequestModal}
        size="lg"
        dir="auto"
      >
        <Modal.Header className="request-service-header-modal">
          {translate("request-main-tab", locale)}
        </Modal.Header>
        <Modal.Body>
          <ServiceRequest />
        </Modal.Body>
        <Modal.Footer dir="auto">
          <Button
            variant="primary"
            className="btn"
            onClick={handleShowPaymentModal}
          >
            {translate("send-request-service", locale)}
          </Button>
          <Button
            variant="primary"
            className="btn btn-secondary"
            onClick={handleCloseServiceRequestModal}
          >
            {translate("cancel-btn", locale)}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Payment Modal */}
      <Modal
        show={showPaymentModal}
        onHide={handleClosePaymentModal}
        size="md"
        dir="auto"
      >
        <Modal.Header className="request-service-header-modal">
          عملية الدفع
        </Modal.Header>
        <Modal.Body>
          <CreditCardForm />
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default LaundryModal;
